import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';
import Link from 'next/link';
import {
  List,
  ListItemIcon,
  ListItemText,
  Popover,
  Link as ButtonLink,
} from '@mui/material';

import { LogOut } from 'lucide-react';

import { APP_SUB_MENU } from './constants';
import { IUserPopoverHandle, IUserPopoverProps } from './model';
import { StyledLinkItem } from '../../styles';
import { useAuth } from '@core/features-core/auth/client';

export const UserPopover = memo(
  forwardRef<IUserPopoverHandle, IUserPopoverProps>(
    ({ setOpen = () => {} }, ref) => {
      const { userIsLogged, logout } = useAuth();

      const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
      const [id, setId] = useState<_ANY>();

      const open = Boolean(anchorEl);

      const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (userIsLogged) {
          setOpen(true);
          setId('user-menu-popover');
          setAnchorEl(event.currentTarget);
        }
      };

      useImperativeHandle(ref, () => {
        return { handleClick, id };
      });

      const handleClose = () => {
        setOpen(false);
        setId(undefined);
        setAnchorEl(null);
      };

      return (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          sx={{ marginTop: '5px' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <List component="div">
            {APP_SUB_MENU.filter((item) => {
              if (!item.allowedRoles) return true;

              return false;
            }).map(({ label, link, icon }) => (
              <Link
                key={link}
                href={link}
                passHref
                prefetch={false}
              >
                <StyledLinkItem component={ButtonLink} color="inherit">
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText
                    primary={label}
                    sx={(theme) => ({
                      fontSize: theme.typography.caption.fontSize,
                    })}
                  />
                </StyledLinkItem>
              </Link>
            ))}

            <StyledLinkItem color="inherit" onClick={() => logout()}>
              <ListItemIcon>
                <LogOut size={18} />
              </ListItemIcon>
              <ListItemText primary="Sair" />
            </StyledLinkItem>
          </List>
        </Popover>
      );
    }
  )
);

export const UserPopoverRef = ({ forwardRef, ...props }: any) => (
  <UserPopover {...props} ref={forwardRef} />
);
